<template>
  <div class="group flex relative h-fit">
    <snap-icon icon="information-circle-solid" color="#3B82F6" size="xs" state="default" class="ml-2 pointer"></snap-icon>
    <div
      class="group-hover:block -translate-x-1/2 translate-y-full hidden z-[9] absolute -bottom-5 xs:left-2 sm:left-32 xs:min-w-fit xs:w-32 sm:w-[261px] drop-shadow-lg rounded-[10px] transition-opacity bg-white border border-gray-200 p-4"
    >
      <div class="w-4 h-4 border-l border-t border-gray-200 -mb-[7px] rotate-45 absolute bottom-full bg-white shadow-current xs:mx-14 sm:mx-auto"></div>
      <p class="text-gray-800 text-sm font-semibold font-inter pb-2">{{ props.heading }}</p>
      <p class="text-gray-800 font-normal text-sm font-inter">
        {{ props.text }}
      </p>
    </div>
  </div>
</template>
<script setup lang="ts">
// Props
const props = defineProps({
  heading: {
    type: String,
    default: "Heading",
  },
  text: {
    type: String,
    default: "",
  },
});
</script>
